import { Portal } from "semantic-ui-react";

import { useEffect, useState } from "react";

import themeColors from "../../constants/themeColors";

export default function SidebarPortal({
	focus,
	style,
	onClose,
	children,
	overlay = false,
	width: initialWidth = 400,
	minWidth = 300,
	maxWidth = 800,
}) {
	const [width, setWidth] = useState(initialWidth);

	useEffect(() => {
		if (window.$crisp) {
			window.$crisp.push(["do", "chat:hide"]);
			document.body.style.paddingRight = `${initialWidth}px`;

			return () => {
				window.$crisp.push(["do", "chat:show"]);
				document.body.style.paddingRight = "";
			};
		}
	}, [initialWidth]);

	useEffect(() => {
		if (!overlay) {
			document.body.style.paddingRight = `${width}px`;

			return () => {
				document.body.style.paddingRight = "";
			};
		}
	}, [overlay, width]);

	const onMouseDown = (e) => {
		e.preventDefault();
		const startX = e.clientX;
		const startWidth = width;

		const onMouseMove = (e) => {
			const newWidth = startWidth - (e.clientX - startX);

			if (newWidth >= minWidth && newWidth <= maxWidth) {
				setWidth(newWidth);
			}
		};

		const onMouseUp = () => {
			window.removeEventListener("mousemove", onMouseMove);
			window.removeEventListener("mouseup", onMouseUp);
		};

		window.addEventListener("mousemove", onMouseMove);
		window.addEventListener("mouseup", onMouseUp);
	};

	const handleClose = () => {
		if (document.querySelector(".ui.dimmer.active, .ui.modal.active")) {
			return;
		}

		onClose?.();
	};

	return (
		<Portal open onClose={handleClose} closeOnDocumentClick={!focus}>
			<>
				{focus && (
					<div
						style={{
							position: "fixed",
							top: 0,
							left: 0,
							height: "100vh",
							width: "100vw",
							backgroundColor: "rgba(0, 0, 0, 0.3)",
							zIndex: 1000,
							overflowY: "auto",
						}}
					/>
				)}

				<div
					style={{
						position: "fixed",
						top: 0,
						right: 0,
						height: "100vh",
						width,
						backgroundColor: "var(--color-bg-card)",
						boxShadow: "0 0 30px rgba(0, 0, 0, 0.08)",
						zIndex: 1000,
						...style,
					}}
				>
					<div
						style={{
							width: "100%",
							height: "100%",
							overflowY: "auto",
						}}
					>
						{children}
					</div>

					<div
						style={{
							position: "absolute",
							top: 0,
							left: 0,
							width: 15,
							height: "100%",
							cursor: "ew-resize",
							backgroundImage: `linear-gradient(to right, transparent 6px, ${themeColors.BLUE_FADED} 6px, ${themeColors.BLUE_FADED} 9px, transparent 9px)`,
							transform: "translateX(-50%)",
						}}
						onMouseDown={onMouseDown}
					/>
				</div>
			</>
		</Portal>
	);
}
